import { type FC } from 'react'

import { Notification } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

export const CartIntermediateMessage: FC = () => {
  const { drawerMessages } = useCartIntermediateContext()
  const infoMessage = drawerMessages?.infoMessage

  // displays message only if severity is error
  if (infoMessage?.severity !== 'error') {
    return null
  }

  return (
    <Notification
      className="mb-3"
      data-qa-id="product-add-to-cart-notification-cta-error"
      severity="error"
    >
      {infoMessage.message}
    </Notification>
  )
}
